const numberTo2sf = (num) => {
    const factor = 10 ** 2;
    return parseFloat(Math.round(num * factor) / factor).toFixed(2);
}

const marginValue = (sales,cost) => {
    return numberTo2sf(Number(numberTo2sf(sales))-Number(numberTo2sf(cost)));
}

const marginPercentage = (sales,cost) => {
    if(cost !== 0){
        return numberTo2sf((Number(numberTo2sf(sales))/Number(numberTo2sf(cost))-1)*100);
    } else {
        return "0.00";
    }
}

const displayCommas = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const addTwoNumbers = (num1,num2) => {
    return numberTo2sf(Number(numberTo2sf(num1))+Number(numberTo2sf(num2)));
}
const addNumberArray = (array) => {
    return array.reduce((acc,curr) => Number(numberTo2sf(acc))+Number(numberTo2sf(curr)),0);
}

const addZeroSubTen = (value) => {
        let newValue;
        if(value < 10){
            newValue = `0${value}`;
        } else {
            newValue = `${value}`;
        }
        return newValue;
    }

export { numberTo2sf , marginValue , marginPercentage , displayCommas , addTwoNumbers , addNumberArray , addZeroSubTen};